import React from 'react';
import { isEmpty, orderBy } from 'lodash/fp';
import ElementHeader from 'components/editor/element/question/ElementHeader';
import ElementBase from '../base';
import CreateQuestion from './create_question';
import { Question } from '../index';

const QuestionBank = ({
  position,
  child_count: childCount,
  createChildElement,
  id,
  children,
  orderDirection = 'asc',
  orderKey = 'position',
  hasOptions = true,
  content,
  handleUpdate,
  applyChanges,
}) => {
  const createQuestion = type => {
    const ownPosition = position;
    createChildElement(type, ownPosition + 1 + childCount);
  };

  const renderQuestion = props => {
    return <Question {...props} key={props.id} reordable />;
  };

  const renderQuestions = () => {
    if (isEmpty(children)) return false;

    const questions = orderBy(orderKey, orderDirection)(children);
    return (
      <div className="QuestionBankElement-questionsContainer">
        {questions.map(renderQuestion)}
      </div>
    );
  };

  return (
    <div className="EditorElement-content QuestionBankElement">
      <ElementHeader
        hasOptions={hasOptions}
        content={content}
        options={content.options}
        id={id}
        handleUpdate={handleUpdate}
        applyChanges={applyChanges}
        isTabbedElement={false}
      />
      <div className="EditorElement-body p-32 border-top-1 border-solid border border-gray-light">
        <CreateQuestion id={id} onClick={createQuestion} />
        {renderQuestions()}
      </div>
    </div>
  );
};

export default ElementBase(QuestionBank);
